export default __webpack_public_path__ + "static/media/07_odvoz-drivi-min.d2c896ac.jpg";